import { ClockState } from '../../../core/models/enum';
import { CreateEventCommand, EventPeriodEnum, EventVm } from '../../../utils/api';
import MatchClock from './MatchClock';
import { OvertimeUiMode } from './periodLabels';

interface OwnProps {
    event: EventVm | CreateEventCommand | null;
    clockState: ClockState;
    eventPeriod: EventPeriodEnum;
    eventTime: number;
    overtimeUiMode: OvertimeUiMode;
    isEventValid: boolean;
    startClock: () => void;
    pauseClock: () => void;
    stopClock: () => void;
    resetClock: () => void;
    setPeriod: (period: EventPeriodEnum, overtimeMode?: OvertimeUiMode) => void;
    modifyClock: (amount: number) => void;
    saveEvent: () => Promise<void>;
}

export type Props = OwnProps;

export default MatchClock;
